import chapter1ru from'./chapter1ru';
import chapter2ru from'./chapter2ru';

const plotRu = [
  ...chapter1ru,
  ...chapter2ru
];

export default plotRu;
